import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  showMoreStyle: {
    fontSize: 16.7,
    color: Colors.secondary7,
  },
  showMoreContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 5,
  },
});
